import React from 'react'

const Errorlable = (props) => {

    const {text}=props
  return (
    text?<div>
        <label style={{fontSize:"9px",display:"flex",fontWeight:"normal",color:"red"}}><p style={{marginRight:"2px",lineHeight:"1.5"}}>*</p>{text}</label>
    </div >: null
  
  )
}

export default Errorlable
